import React, {
	CSSProperties,
	FunctionComponent,
	SVGProps,
} from 'react';

import { MediaDimensions } from '../../stores/types/types';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import ImageFrame from '../general-components/image-frame';
import Colors from '../../utils/colors';

type ReqMediaDimensions = Required<MediaDimensions>;

type HeaderLeftControlsProps = {
	channelLogo: string | FunctionComponent<
		SVGProps<SVGSVGElement> & { title?: string | undefined }
	>;
	title: string;
	backButtonHandler: (value: boolean) => void;
	borderRadius?: CSSProperties['borderRadius'];
	objectFit?: CSSProperties['objectFit'];
	frameSize?: ReqMediaDimensions;
	imageSize?: ReqMediaDimensions;
	altText?: string;
	backgroundColor?: CSSProperties['backgroundColor'];
}

export default function HeaderLeftControls({
	channelLogo,
	title,
	backButtonHandler,
	borderRadius,
	objectFit,
	frameSize,
	imageSize,
	altText = 'Header Logo',
	backgroundColor = Colors.blGrayscale1100,
}: HeaderLeftControlsProps) {
	return (
		<div className="header-left-controls">
			<div className="header-left">
				<div className="header-back-btn-container">
					<button
						className="basic header-back-btn"
						onClick={() => backButtonHandler(false)}
					>
						<Icon name={ICONS.ARROW_LEFT} color={COLORS.WHITE} size={16} />
					</button>
				</div>
				<div className="header-logo-container">
					<ImageFrame
						{...(typeof channelLogo === 'string'
							? { imageSrc: channelLogo }
							: { imageComponentSvg: channelLogo }
						)}
						{...{
							altText,
							backgroundColor,
							borderRadius,
							objectFit,
							frameSize,
							imageSize,
						}}
					/>
				</div>
				<h6 className="header-title truncate-overflow">{title}</h6>
			</div>
		</div>
	);
}
